import { OrderStatus } from '../enums/OrderStatus';
import { OrderType } from '../enums/OrderType';
import ArticleGroup from './ArticleGroup';
import { TerminalOrder } from './TerminalOrder';
import { PaymentStatus } from './PaymentStatus';
import { Dayjs } from 'dayjs';
import Preorder from './Preorder';
import { PaymentMethod } from '../enums/PaymentMethod';
import PromoCode from './PromoCode';
import { environment } from '../../environments/environment';
import Catering from './Catering';
import SanifairVoucher from './SanifairVoucher';
import SmoothrDispatchLocation from './SmoothrDispatchLocation';
import { DeliveryStatus } from '../enums/DeliveryStatus';
import GiftCard from './GiftCard';
import { CheckoutArticleGroup } from './CheckoutArticleGroup';

export default class Order {
	// tslint:disable-next-line:variable-name
	_id: string;
	createdAt: Dayjs;
	updatedAt: Dayjs;
	preparedAt: Dayjs;
	readyAt: Dayjs;
	orderAt: Dayjs;
	asap: boolean;
	estimatedAt: Dayjs;
	table: string;
	tableNumber: string;
	status = OrderStatus.CREATED;
	type = OrderType.STANDARD;
	preorder: Preorder;
	catering: Catering;
	orderedArticles: ArticleGroup[] = [];
	checkoutOrderedArticles: Partial<CheckoutArticleGroup>[];
	code: string;
	isPayed: boolean;
	terminalorder?: TerminalOrder;
	affiliateCode: string;
	venue: string;
	venueName: string;
	statusNote: string;
	currency: string;
	paymentId: string;
	method: PaymentMethod;
	paymentStatus: PaymentStatus;
	paymentMethod: PaymentMethod;
	transferred = false;
	referenceOrder: string = null;
	flavor = environment.flavor;
	claimedLoyaltyPoints: number;
	loyaltyNumber: string;
	userUid: string;
	sanifairVouchers?: SanifairVoucher[] = [];
	totalPrice?: string;
	sendToSalesforce?: boolean;
	secondaryCode?: string;
	dispatch: SmoothrDispatchLocation;
	totalNetPrice: string;
	dndCompany?: string;
	deliveryStatus?: DeliveryStatus;
	subsidy?: string;
	finishedAt?: string;
	promoCodes?: PromoCode[];
	piggyPoints?: number;
	giftCard?: GiftCard;
	openOrdersEnabled?: boolean;
	pendingCashPaymentEnabled?: boolean;
}
